// Libraries
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';

// ContextAPI
import { FormData } from './CreateQuestionnaire';

// Components
import FormBuilderPage from './components/formBuilderPage';
import NewFormModal from './NewFormModal';

import GraphStructureService from './services/graph.structurer.service';
import { CONSTANTS } from 'src/components/Constants';
import { useAutoTranslation } from 'src/hooks/useTranslate';

function InitialPage() {
  const [formData, setFormData] = useContext(FormData);
  const navigate = useNavigate();
  const t = useAutoTranslation();
  const gs = React.useMemo(() => new GraphStructureService(), []);

  const hasData = Object.keys(formData).length > 0;

  const handleCreateNewForm = async (values) => {
    setFormData(await gs.initializeGraphForm(values, true));
  };

  if (hasData) {
    return (
      <div>
        <FormBuilderPage />
      </div>
    );
  }

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 1,
          minHeight: '50vh',
          color: '#8593a3'
        }}
      >
        <PostAddRoundedIcon sx={{ fontSize: 56 }} />
        <Typography variant="h6" sx={{ color: 'var(--color-navy, #1a3a5c)' }}>
          {t('Name your form to start building')}
        </Typography>
        <Typography variant="body2">
          {t('Add a title and description to create your first section.')}
        </Typography>
      </Box>
      <NewFormModal
        open
        onClose={() => navigate(CONSTANTS.formCreationPath)}
        onCreate={handleCreateNewForm}
      />
    </div>
  );
}

export default InitialPage;
